<template>
    <div>
        <header class="page-header">
            <h2>
                <a href="/dashboard">
                    <i class="fa fa-list-alt"></i>
                </a>
            </h2>
            <ol class="breadcrumbs">
                <li class="active">
                    <span>Dashboard</span>
                </li>
            </ol>
        </header>
        <div class="row">
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <x-graph-line :all-data="dataChartLine"></x-graph-line>
                                <!--                                <div class="chart-data-selector ready pl-3 pr-4 pt-4">-->
                                <!--                                    <div class="chart-data-selector-items">-->
                                <!--                                        <chart-line v-if="loaded"-->
                                <!--                                                    :data="dataChartLine"></chart-line>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="row px-4 mt-2">
                            <div class="col-2 font-weight-bold text-primary">{{ year }}</div>
                            <div class="col-10 font-weight-semibold text-right">Comprobantes generados por mes</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="row">
                    <div class="col-md-12">
                        <section class="card card-horizontal">
                            <header class="card-header bg-success">
                                <div class="card-header-icon">
                                    <i class="fas fa-users"></i>
                                </div>
                            </header>
                            <div class="card-body p-4 text-center">
                                <p class="font-weight-semibold mb-0 mx-4">Total Clientes</p>
                                <h2 class="font-weight-semibold mt-0">{{ records.length }}</h2>
                                <div class="summary-footer">
                                    <a class="text-muted text-uppercase"
                                       href="#client-list">Ver todos</a>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="col-md-12 mb-0">
                        <section class="card card-horizontal">
                            <header class="card-header bg-info">
                                <div class="card-header-icon">
                                    <i class="fas fa-file-alt"></i>
                                </div>
                            </header>
                            <div class="card-body p-4 text-center">
                                <p class="font-weight-semibold mb-0 mt-3">Total Comprobantes</p>
                                <h2 class="font-weight-semibold mt-0 mb-3">{{ total_documents }}</h2>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon text-secondary">
                                    <div :data-value='discUsed'
                                         class="progress1 mx-auto">
                    <span class="progress1-left">
                      <span class="progress1-bar border-primary"></span>
                    </span>
                                        <span class="progress1-right">
                      <span class="progress1-bar border-primary"></span>
                    </span>
                                        <div
                                            class="progress1-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                            <div class="font-weight-bold">{{ discUsed }}<small class="small"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <!-- <h4 class="title">sss</h4> -->
                                    <div class="info">
                                        <strong class="amount">Disco Duro</strong><br>
                                        <!-- <span class="text-warning" v-if="discUsed == 0">no se pudo obtener</span> -->
                                    </div>
                                </div>
                                <div class="summary-footer d-block">
                                    <a class="text-muted text-uppercase"
                                       href="https://docs.google.com/document/d/1hpEQUs9OFha_35yyLb1cMKeluD-dEku5lQsQ3TJFib8/edit"
                                       target="BLANK">Incrementar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon text-secondary">
                                    <div :data-value='iUsed'
                                         class="progress1 mx-auto">
                    <span class="progress1-left">
                      <span class="progress1-bar border-primary"></span>
                    </span>
                                        <span class="progress1-right">
                      <span class="progress1-bar border-primary"></span>
                    </span>
                                        <div
                                            class="progress1-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                            <div class="font-weight-bold">{{ iUsed }}<small class="small"></small></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"></h4>
                                    <div class="info">
                                        <strong class="amount">Inodes</strong>
                                        <!-- <span class="text-primary">(14 unread)</span> -->
                                    </div>
                                </div>
                                <div class="summary-footer d-block">
                                    <a class="text-muted text-uppercase"
                                       href="https://drive.google.com/open?id=1foPKDI3V3Z9uKTjRc2SPSoztVSOBevPAluT2BqFbfxA"
                                       target="BLANK">Limpiar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon text-secondary">
                                    <div class="progress1 mx-auto"
                                         data-value='100'>
                    <span class="progress1-left">
                      <span class="progress1-bar border-tertiary"></span>
                    </span>
                                        <span class="progress1-right">
                      <span class="progress1-bar border-tertiary"></span>
                    </span>
                                        <div
                                            class="progress1-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                            <div class="font-weight-bold">{{ storageSize }}<small class="small"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"></h4>
                                    <div class="info">
                                        <strong class="amount">Archivos <br> Generados</strong>
                                        <!-- <span class="text-primary">(14 unread)</span> -->
                                    </div>
                                </div>
                                <div class="summary-footer">
                                    <!-- <a class="text-muted text-uppercase">(view all)</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon"
                                     style="background-color: #292961">
                                    <i class="fab fa-gitlab"></i>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"></h4>
                                    <div class="info">
                                        <strong class="amount">Versión</strong><br>
                                        <span class="text-primary">{{ version }}</span>
                                    </div>
                                </div>
                                <div class="summary-footer">
                                    <!-- <a class="text-muted text-uppercase">(view all)</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div id="client-list"
             class="card">
            <div class="card-header bg-info">Listado de Clientes</div>
            <div class="card-body">
                <div class="row">
                    <div class="col-4">
                        <div class="form-group" >
                          <label class="control-label font-weight-bold text-info">
                              Cliente
                              <a href="#" @click.prevent="clickCreate()">[+ Nuevo]</a>
                          </label>
                          <el-select v-model="customer_id" filterable remote class="border-left rounded-left border-info" popper-class="el-select-customers" clearable
                            placeholder="Escriba el nombre o número de documento del cliente"
                            :remote-method="searchRemoteCustomers"
                            :loading="loading_search"
                            @change="changeCustomer">

                            <el-option v-for="option in customers" :key="option.id" :value="option.id" :label="option.full_description"></el-option>
                          </el-select>
                        </div>
                    </div>
                    <div class="col-4 mb-3">
                        <div class="form-group" >
                            <label class="control-label font-weight-bold text-info"> Filtrar por </label>

                            <div class="dropdown">
                                <button class="btn btn-default btn-sm" type="button" id="dropdownMenuButton"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-angle-down"></i> Pendientes de:
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="#" @click.prevent="filterData()"> Todos </a>
                                    <a class="dropdown-item" href="#" @click.prevent="filterData(1)"> Envios </a>
                                    <a class="dropdown-item" href="#" @click.prevent="filterData(2)"> Rectificación </a>
                                    <a class="dropdown-item" href="#" @click.prevent="filterData(3)"> Anular </a>
                                    <a class="dropdown-item" href="#" @click.prevent="filterData(4)"> Demo </a>
                                    <a class="dropdown-item" href="#" @click.prevent="filterData(5)"> Producción </a>
                                    <a class="dropdown-item" href="#" @click.prevent="filterData(6)"> Interno </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 d-flex justify-content-end">
                        <div class="data-table-visible-columns ">
                            <el-dropdown :hide-on-click="false">
                                <el-button type="primary">
                                    Mostrar/Ocultar columnas<i
                                        class="el-icon-arrow-down el-icon--right"
                                    ></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        v-for="(column, index) in columns"
                                        :key="index"
                                    >
                                        <el-checkbox
                                            @change="setColumns"
                                            v-if="
                                                column.title !== undefined &&
                                                    column.visible !== undefined
                                            "
                                            v-model="column.visible"
                                            >{{ column.title }}
                                        </el-checkbox>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                   <!--  <div class="col-6 text-right">
                        <button
                            class="btn btn-custom btn-sm mt-2 mr-2 mb-3"
                            type="button"
                            @click.prevent="clickCreate()"
                        >
                            <i class="fa fa-plus-circle"></i> Nuevo
                        </button>
                    </div> -->
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th v-if="columns.hostname.visible">Hostname</th>
                            <th v-if="columns.name.visible">Nombre</th>
                            <th v-if="columns.number.visible">RUC</th>
                            <th v-if="columns.plan.visible">Plan</th>
                            <th v-if="columns.email.visible">Correo</th>
                            <th v-if="columns.soap_type.visible">Entorno</th>
                            <th v-if="columns.certificate_due.visible" class="text-center">Vencimiento Certificado</th>
                            <th v-if="columns.last_emition.visible">Última emisión</th>
                            <th v-if="columns.count_doc.visible" class="text-center">Total de Comprobantes</th>
                            <th v-if="columns.notifications.visible" class="text-center">Notificaciones</th>
                            <th v-if="columns.start_billing_cycle.visible" class="text-right">Inicio Ciclo Facturacion</th>
                            <th v-if="columns.count_doc_month.visible" class="text-center">Comprobantes Ciclo Facturacion</th>
                            <th v-if="columns.count_user.visible" class="text-center">Usuarios</th>

                            <th v-if="columns.count_establishments.visible" class="text-center">Establecimientos</th>

                            <th v-if="columns.monthly_sales_total.visible" class="text-center">Ventas (Mes)</th>


                            <th v-if="columns.created_at.visible" class="text-center">F.Creación</th>
                            <th v-if="columns.queries_to_apiperu.visible" class="text-center">Consultas <br>API Peru <br>(mes)</th>

                            <th v-if="columns.count_sales_notes.visible" class="text-center">Cant.Notas de venta</th>
                            <th v-if="columns.current_count_doc_month.visible" class="text-center">Total<br><small>(Comprobantes por mes)</small></th>
                            <th v-if="columns.count_doc_pse.visible" class="text-center">Total<br><small>(Comprobantes a PSE-GIOR)</small></th>
                            <th v-if="columns.total_doc.visible" class="text-center">Total<br><small>(Comprobantes <br>notas de venta)</small></th>

                            <th v-if="columns.locked_tenant.visible" class="text-center">Bloquear cuenta</th>

                            <th v-if="columns.locked_emission.visible" class="text-right">Limitar Doc.</th>
                            <th v-if="columns.locked_users.visible" class="text-center">Limitar Usuarios</th>

                            <th v-if="columns.locked_create_establishments.visible" class="text-center">Limitar Establecimientos</th>

                            <th v-if="columns.restrict_sales_limit.visible" class="text-center">
                                <el-tooltip class="item"
                                            content="Límite de ventas mensual asociado al ciclo de facturación"
                                            effect="dark"
                                            placement="top">
                                    <label>Limitar Ventas (Mes)</label>
                                </el-tooltip>
                            </th>
                            <th v-if="columns.actions.visible" class="text-right">Acciones</th>
                            <!-- <th class="text-right">Pagos</th>
                            <th class="text-right">E. Cuenta</th>
                            <th class="text-right">Editar</th> -->
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row, index) in records"
                            :key="index">
                            <td>{{ index + 1 }}</td>
                            <td v-if="columns.hostname.visible">
                                <!-- {{ row.hostname }} -->
                                <a :href="`http://${row.hostname}`"
                                   style="color:black"
                                   target="_blank">{{ row.hostname }}</a>
                            </td>
                            <td v-if="columns.name.visible">{{ row.name }}</td>
                            <td v-if="columns.number.visible">{{ row.number }}</td>
                            <td v-if="columns.plan.visible">{{ row.plan }}</td>
                            <td v-if="columns.email.visible">{{ row.email }}</td>
                            <td v-if="columns.soap_type.visible">
                                <span v-if="row.soap_type == '01'"
                                      class="badge badge-default">Demo</span>
                                <span v-if="row.soap_type == '02'"
                                      class="badge badge-success">Producción</span>
                                <span v-if="row.soap_type == '03'"
                                      class="badge badge-info">Interno</span>
                            </td>
                            <td v-if="columns.certificate_due.visible" class="text-center">
                                <span :style="{'color': row.certificate_due_color}">{{ row.certificate_due }}</span>
                            </td>
                            <td v-if="columns.last_emition.visible">
                              <span class=" font-weight-bold" :class="{'text-danger': validateDateLastEmition(row.last_emition)}">{{ row.last_emition }}</span>
                            </td>
                            <td v-if="columns.count_doc.visible" class="text-center">
                                <label>
                                    <strong>{{ row.count_doc }}</strong>
                                </label>
                            </td>

                            <td v-if="columns.notifications.visible" class="text-center">

                                <el-tooltip class="item"
                                            content="Comprobantes enviados / por enviar"
                                            effect="dark"
                                            placement="top-start">
                                    <el-badge :value="row.document_not_sent"
                                              class="item"
                                              :type="row.document_not_sent == 0 ? 'primary' : 'danger'">
                                        <i class="far fa-bell text-secondary"></i>
                                    </el-badge>
                                </el-tooltip>

                                <el-tooltip class="item"
                                            content="Comprobantes pendientes de rectificación"
                                            effect="dark"
                                            placement="top-start">
                                    <el-badge :value="row.document_regularize_shipping"
                                              class="item  ml-4"
                                              :type="row.document_regularize_shipping == 0 ? 'primary' : 'danger'">
                                        <i class="fas fa-exclamation-triangle text-secondary"></i>
                                    </el-badge>
                                </el-tooltip>

                                <el-tooltip class="item"
                                            content="Comprobantes por anular"
                                            effect="dark"
                                            placement="top-start">
                                    <el-badge :value="row.document_to_be_canceled"
                                              class="item  ml-4"
                                              :type="row.document_to_be_canceled == 0 ? 'primary' : 'danger'">
                                        <i class="fas fa-exclamation-circle text-secondary"></i>
                                    </el-badge>
                                </el-tooltip>

                            </td>
                            <td v-if="columns.start_billing_cycle.visible">
                                <template v-if="row.start_billing_cycle">
                                    <span></span>
                                    <span>{{ row.start_billing_cycle }}</span>
                                </template>
                                <template v-else>
                                    <el-date-picker
                                        v-model="row.select_date_billing"
                                        placeholder="..."
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        @change="setStartBillingCycle($event, row.id)"
                                    ></el-date-picker>
                                </template>
                            </td>

                            <td v-if="columns.count_doc_month.visible" class="text-center">
                                <strong>
                                    <template v-if="row.sale_notes_quantity_if_include > 0">
                                        {{
                                            row.count_doc_month ? (row.count_doc_month + row.sale_notes_quantity_if_include) : 0
                                        }} /
                                    </template>
                                    <template v-else>
                                        {{ row.count_doc_month ? row.count_doc_month : 0 }} /
                                    </template>

                                    <template v-if="row.max_documents == 0">
                                        <i class="fas fa-infinity"></i>
                                    </template>
                                    <template v-else>
                                        <strong>{{ row.max_documents }}</strong>
                                    </template>
                                </strong>
                            </td>

                            <td v-if="columns.count_user.visible" class="text-center">
                                <template v-if="row.max_users !== 0 && row.count_user > row.max_users">
                                    <el-popover
                                        :content="text_limit_users"
                                        placement="top-start"
                                        trigger="hover"
                                        width="220"
                                    >
                                        <label slot="reference"
                                               class="text-danger">
                                            <strong>{{ row.count_user }}</strong>
                                        </label>
                                    </el-popover>
                                </template>
                                <template v-else>
                                    <label>
                                        <strong>{{ row.count_user }}</strong>
                                    </label>
                                </template>
                                /
                                <template v-if="row.max_users == 0">
                                    <i class="fas fa-infinity"></i>
                                </template>
                                <template v-else>
                                    <strong>{{ row.max_users }}</strong>
                                </template>
                            </td>

                            <td v-if="columns.count_establishments.visible" class="text-center">

                                <data-limit-notification
                                    entity_description="establecimientos"
                                    :unlimited="row.establishments_unlimited"
                                    :quantity="row.quantity_establishments"
                                    :max_quantity="row.max_quantity_establishments"
                                >
                                </data-limit-notification>

                            </td>

                            <td v-if="columns.monthly_sales_total.visible" class="text-center">

                                <data-limit-notification
                                    entity_description="ventas"
                                    style_div="width: 150px !important"
                                    :unlimited="row.sales_unlimited"
                                    :quantity="row.monthly_sales_total"
                                    :max_quantity="row.max_sales_limit"
                                >
                                </data-limit-notification>

                            </td>


                            <td v-if="columns.created_at.visible" class="text-center">{{ row.created_at }}</td>
                            <td v-if="columns.queries_to_apiperu.visible">{{ row.queries_to_apiperu }}</td>

                            <td v-if="columns.count_sales_notes.visible" class="text-center"><strong>{{ row.count_sales_notes }}</strong></td>
                            <td v-if="columns.current_count_doc_month.visible" class="text-center"><strong>{{ row.current_count_doc_month }}</strong></td>
                            <td v-if="columns.count_doc_pse.visible" class="text-center"><strong>{{ row.count_doc_pse }}</strong></td>
                            <td v-if="columns.total_doc.visible" class="text-center"><strong>{{
                                    row.count_doc_month + row.count_sales_notes_month
                                }}</strong></td>

                            <td v-if="columns.locked_tenant.visible" class="text-center">
                                <template v-if="!row.locked">
                                    <el-switch
                                        v-model="row.locked_tenant"
                                        style="display: block"
                                        @change="changeLockedTenant(row)"
                                    ></el-switch>
                                </template>
                            </td>

                            <td v-if="columns.locked_emission.visible" class="text-center">
                                <el-switch
                                    v-model="row.locked_emission"
                                    style="display: block"
                                    @change="changeLockedEmission(row)"
                                ></el-switch>
                            </td>

                            <td v-if="columns.locked_users.visible" class="text-center">
                                <el-switch
                                    v-model="row.locked_users"
                                    style="display: block"
                                    @change="changeLockedUser(row)"
                                ></el-switch>
                            </td>

                            <td v-if="columns.locked_create_establishments.visible" class="text-center">
                                <el-switch
                                    v-model="row.locked_create_establishments"
                                    style="display: block"
                                    @change="changeLockedByColumn(row, 'locked_create_establishments')"
                                ></el-switch>
                            </td>

                            <td v-if="columns.restrict_sales_limit.visible" class="text-center">
                                <el-switch
                                    v-model="row.restrict_sales_limit"
                                    style="display: block"
                                    @change="changeLockedByColumn(row, 'restrict_sales_limit')"
                                ></el-switch>
                            </td>

                            <td v-if="columns.actions.visible" class="text-right">
                                <div class="dropdown">
                                    <button class="btn btn-default btn-sm" type="button" id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <template v-if="!row.locked">
                                            <a class="dropdown-item"
                                               href="#"
                                               @click.prevent="clickPassword(row.id)">
                                                Restablecer contraseña
                                            </a>
                                            <a class="dropdown-item"
                                               href="#"
                                               @click.prevent="clickDelete(row)"
                                               v-if="deletePermission == true">
                                                Eliminar Cliente
                                            </a>
                                            <div class="dropdown-divider"></div>
                                        </template>
                                        <a class="dropdown-item"
                                           href="#"
                                           @click.prevent="clickEdit(row.id)">
                                            Editar
                                        </a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item"
                                           href="#"
                                           @click.prevent="clickPayments(row.id)">
                                            Pagos
                                        </a>
                                        <a class="dropdown-item"
                                           href="#"
                                           @click.prevent="clickAccountStatus(row.id)">
                                            Estado de cuenta
                                        </a>
                                        <a class="dropdown-item"
                                           href="#"
                                           @click.prevent="clickConfigurationPse(row.id)">
                                            Configurar PSE
                                        </a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <system-clients-form :recordId="recordId"
                             :showDialog.sync="showDialog"></system-clients-form>

        <!--<system-clients-form-edit :showDialog.sync="showDialogEdit"
        :recordId="recordId"></system-clients-form-edit>-->

        <client-payments :clientId="recordId"
                         :showDialog.sync="showDialogPayments"></client-payments>

        <account-status :clientId="recordId"
                        :showDialog.sync="showDialogAccountStatus"></account-status>

        <client-delete :record="record"
                       :showDialog.sync="showDialogDelete"></client-delete>

        <configuration-pse :clientId="recordId"
                           :showDialog.sync="showDialogConfigurationPse"></configuration-pse>
    </div>
</template>

<script>
import CompaniesForm from "./form.vue";
import {deletable} from "../../../mixins/deletable";
import {changeable} from "../../../mixins/changeable";
import ChartLine from "./charts/Line";
import ClientPayments from "./partials/payments.vue";
import AccountStatus from "./partials/account_status.vue";
import ClientDelete from "./partials/delete.vue";
import DataLimitNotification from "./partials/DataLimitNotification.vue";
import ConfigurationPse from "./partials/ConfigurationPse";
import XGraphLine from "../../../components/graph/src/XGraphLine";

export default {
    mixins: [
        deletable,
        changeable
    ],
    props: [
        'deletePermission',
        'discUsed',
        'iUsed',
        'storageSize',
        'version'
    ],
    components: {
        XGraphLine,
        CompaniesForm,
        ChartLine,
        ClientPayments,
        AccountStatus,
        ClientDelete,
        DataLimitNotification,
        ConfigurationPse
    },
    data() {
        return {
            columns: {
                hostname: {
                    title: "Hostname",
                    visible: true
                },
                name: {
                    title: "Nombre",
                    visible: true
                },
                number: {
                    title: "RUC",
                    visible: true
                },
                plan: {
                    title: "Plan",
                    visible: false
                },
                email: {
                    title: "Correo",
                    visible: true
                },
                certificate_due: {
                    title: "Vencimiento de certificado",
                    visible: true
                },
                soap_type: {
                    title: "Entorno",
                    visible: true
                },
                count_doc: {
                    title: "Total Comprobantes",
                    visible: false
                },
                notifications: {
                    title: "Notificaciones",
                    visible: true
                },
                start_billing_cycle: {
                    title: "Inicio Ciclo Fact.",
                    visible: false
                },
                count_doc_month: {
                    title: "Facturación",
                    visible: false
                },
                count_user: {
                    title: "Usuarios",
                    visible: false
                },
                count_establishments: {
                    title: "Establecimientos",
                    visible: false
                },
                monthly_sales_total: {
                    title: "Ventas (Mes)",
                    visible: false
                },
                created_at: {
                    title: "Fecha de creación",
                    visible: false
                },
                queries_to_apiperu: {
                    title: "Consultas API Peru (mes)",
                    visible: false
                },
                count_sales_notes: {
                    title: "Cant.Notas de venta",
                    visible: false
                },
                current_count_doc_month: {
                    title: "Limitar Ventas (Mes)",
                    visible: false
                },
                total_doc: {
                    title: "Total (Comprobantes)",
                    visible: false
                },
                count_doc_pse: {
                    title: "Limitar Ventas (Mes)",
                    visible: false
                },
                locked_tenant: {
                    title: "Bloquear cuenta",
                    visible: true
                },
                locked_emission: {
                    title: "Limitar Doc.",
                    visible: true
                },
                locked_users: {
                    title: "Limitar Usuarios",
                    visible: true
                },
                locked_create_establishments: {
                    title: "Limitar Establecimientos",
                    visible: true
                },
                restrict_sales_limit: {
                    title: "Limitar Ventas (Mes)",
                    visible: false
                },
                last_emition: {
                    title: "Última emisión",
                    visible: false
                },
                actions: {
                    title: "Acciones",
                    visible: true
                },
            },
            selectBillingDate: "",
            showDialogEdit: false,
            showDialog: false,
            showDialogPayments: false,
            showDialogAccountStatus: false,
            showDialogConfigurationPse: false,
            resource: "clients",
            recordId: null,
            records: [],
            text_limit_doc: null,
            text_limit_users: null,
            loaded: false,
            year: moment().format('YYYY'),
            total_documents: 0,
            dataChartLine: {},
            showDialogDelete: false,
            record: {},
            loading_search:false,
            customer_id: null,
            customers: [],
            all_customers: [],
            search: {
                value: null,
            },
            filter_records: false,

        };
    },
    async mounted() {
        this.loaded = false;
        await this.$http.get(`/${this.resource}/charts`).then(response => {
            let line = response.data.line;
            this.dataChartLine = line;
            // this.dataChartLine.datasets[0].data = line.data;
            this.total_documents = response.data.total_documents;
            // console.log(response.data)
            // this.records = response.data.data
        });
        this.loaded = true;
    },
    created() {
        this.$eventHub.$on("reloadData", () => {
            this.getData();
        });
        this.getData();
        this.getColumns();
        this.text_limit_doc = "El límite de comprobantes fue superado";
        this.text_limit_users = "El límite de usuarios fue superado";
    },
    methods: {
        changeLockedTenant(row) {
            this.$http
                .post(`${this.resource}/locked_tenant`, row)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.$eventHub.$emit("reloadData");
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                    }
                })
                .then(() => {
                });
        },
        async setColumns() {
            console.log(this.columns)
            const response = await this.$http.post(`/users/columns`, {
                columns: this.columns
            });
        },
        async getColumns() {
            const response = await this.$http.get(`/users/columns`);
            const data = response.data;
            if (response.status == 200) {
                if (data.columns) {
                    this.columns = JSON.parse(data.columns);
                }
            }
        },
        async filterData(type) {
            // (1=no enviados) (2=por regularizar) (3=por anular) (4=demo) (5=prod)
            this.records = _.filter(this.all_customers, function(o) {
                if (type==1) {
                    return o.document_not_sent > 0;
                }else if (type==2) {
                    return o.document_regularize_shipping > 0;
                }else if (type==3) {
                    return o.document_to_be_canceled > 0;
                }else if (type==4) {
                    return o.soap_type == '01';
                }else if (type==5) {
                    return o.soap_type == '02';
                }else if (type==6) {
                    return o.soap_type == '03';
                }else{
                    return o;
                }

              })
          // console.log(this.records)
        },
        changeLockedUser(row) {
            this.$http
                .post(`${this.resource}/locked_user`, row)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.$eventHub.$emit("reloadData");
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                    }
                })
                .then(() => {
                });
        },
        changeLockedByColumn(row, column) {
            const params = {...row}
            params.column = column

            this.$http
                .post(`${this.resource}/locked-by-column`, params)
                .then(response => {

                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.$eventHub.$emit("reloadData")
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message)
                    } else {
                        console.log(error.response)
                    }
                })
                .then(() => {
                })
        },
        setStartBillingCycle(event, id) {
            this.$http
                .post(`${this.resource}/set_billing_cycle`, {
                    id: id,
                    start_billing_cycle: event
                })
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                    }
                })
                .then(() => {
                    this.$eventHub.$emit("reloadData");
                });
        },

        validateDateLastEmition(last_emition) {
            const lastEmition = moment(last_emition);
            const now = moment();
            const diffInDays = now.diff(lastEmition, 'days')
            return diffInDays >= 3;
        },

        changeLockedEmission(row) {
            this.$http
                .post(`${this.resource}/locked_emission`, row)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.$eventHub.$emit("reloadData");
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                    }
                })
                .then(() => {
                });
        },
        searchRemoteCustomers(input) {
          if (input.length > 3) {
            this.loading_search = true
            let parameters = `input=${input}`
            this.$http.get(`/${this.resource}/records2?${parameters}`)
                    .then(response => {
                        console.log(response.data.data)
                        this.customers = response.data.data
                        this.loading_search = false
                    })
          } else {
              this.getData()
          }
          console.log(this.customers)
        },
        allCustomers(){
          this.customers = this.all_customers
        },
        changeCustomer(){
          if(this.customer_id){
            this.records = _.filter(this.all_customers, {'id': this.customer_id});
          }
          else{
            this.records = this.all_customers
            this.allCustomers()
          }

        },
        getData() {
            this.$http.get(`/${this.resource}/records`).then(response => {
                this.records = response.data.data;
                this.all_customers = response.data.data
                this.allCustomers()
            });
        },
        clickCreate(recordId = null) {
            this.recordId = recordId;
            this.showDialog = true;
        },
        clickPayments(recordId = null) {
            this.recordId = recordId;
            this.showDialogPayments = true;
        },
        clickAccountStatus(recordId = null) {
            this.recordId = recordId;
            this.showDialogAccountStatus = true;
        },
        clickPassword(id) {
            this.change(`/${this.resource}/password/${id}`);
        },
        clickDelete(record) {

            this.record = record
            this.showDialogDelete = true
            // this.destroy(`/${this.resource}/${id}`).then(() =>
            //     this.$eventHub.$emit("reloadData")
            // );
        },
        clickEdit(recordId) {
            this.recordId = recordId;
            this.showDialog = true;
        },
        clickConfigurationPse(id) {
            this.recordId = id;
            this.showDialogConfigurationPse = true;
        }

    }
};
</script>
